var AndroidInterface = {};

// Try to load the actual AndroidInterface...
try {
  AndroidInterface = require('AndroidInterface');
} catch (ex) {
  // ...Failing that we stick with the dummy fallback.
}

export default () => {
  return () => next => action => {
    if (action.type) {
      AndroidInterface && AndroidInterface.handleEvent && AndroidInterface.handleEvent(JSON.stringify(action));
    }
    return next(action);
  };
};
